module.exports = __webpack_public_path__ + "Gotham-Book.3ab923797fe1d42a9669.woff2";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Book.woff2
// module id = ../../../../../src/assets/fonts/Gotham-Book.woff2
// module chunks = 2